import RedirectContainer from "../../../components/RedirectContainer";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Table,
  Modal,
  InputGroup,
} from "react-bootstrap";
import SidebarPanelNavigation from "../../../components/SidebarPanelNavigation";
import { BsFillGridFill } from "react-icons/bs";
import { Formik, useFormik, Form as FormFormik, Field } from "formik";
import { IoIosDownload } from "react-icons/io";
import { MdDelete, MdEdit } from "react-icons/md";
import { useState, useEffect } from "react";
import LoadingIndicator from "../../../components/LoadingIndicator";
import { TiInputChecked } from "react-icons/ti";
import {
  getEventoAdmin,

  deleteEvento,

  searchEvento,
} from "../../../services/api";
import useNotification from "../../../contexts/notification";
import PaginationComponent from "../../../components/Pagination";
import Checkbox from '@material-ui/core/Checkbox';
import { generateMonitoramentoExcel } from "../../../components/download/lista-participantes";



export default function Categories() {
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [page, setPage] = useState(1);
  const [showUpdateCategoryModal, setShowUpdateCategoryModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { setMessage } = useNotification();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const refresh = () => {
    const error = {
      error: true,
      content: "Erro ao recarregar. Tente novamente mais tarde",
    };

    if (query) {
      searchEvento(query, page).then(
        (data) => {
          setData(data.categories);
        },
        () => setMessage(error)
      );
    } else {
      getEventoAdmin(page).then(
        (data) => {
          setData(data);
        },
        () => setMessage(error)
      );
    }
  };
  const handleDownloadExcel = async () => {
    await generateMonitoramentoExcel(data); // Chama a função existente para Excel
  };
  function handleQueryCategory(e) {
    e.preventDefault();
    searchEvento(query, page).then((data) => {
      setData(data.categories || []);
    });
  }



  useEffect(() => {
    if (query.length === 0) {
      getEventoAdmin(page).then(
        (response) => {
          console.log(response);
          setData(response);
          setIsLoading(false);
        },
        () =>
          setMessage({
            error: true,
            content: "Um erro ocorreu. Tente novamente mais tarde",
          })
      );
    } else {
      setPage(1);
    }
  }, [query, page, setMessage]);



  return (
    <>
      <RedirectContainer role="admin">
        <Container fluid>
          <div>
            <SidebarPanelNavigation isAdmin />
            <div className="content-panel">
              {isLoading && <LoadingIndicator />}
              {!isLoading && (
                <>
                  <div className="py-3">
                    <h5 className="text-primary mb-3 mb-sm-0 mb-md-0 mb-lg-0 mb-xl-0">
                      <BsFillGridFill className="mr-2" />
                      Participantes dos eventos
                    </h5>
                  </div>

                  <div className="d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-between">
                    <div>
                      <Form >
                        <Form.Group className="d-flex" controlId="">
                          <InputGroup>
                            <Form.Control
                              type="text"
                              placeholder="Buscar participantes"
                              onKeyUp={handleQueryCategory}
                              required
                              onChange={(e) => setQuery(e.target.value)}
                            />
                          </InputGroup>
                        </Form.Group>
                      </Form>
                    </div>

                    <div>

                      <Col className="col-auto">
                        <Button style={{ marginRight: '10px' }}
                          variant="success"
                          onClick={handleDownloadExcel}

                          disabled={data.length === 0} // Desabilita se nenhum produto estiver selecionado
                        >
                          <span className="mr-2">DOWNLOAD XLSX</span>
                          <IoIosDownload style={{ fontSize: "1.6em" }} />
                        </Button>





                      </Col>


                    </div>
                  </div>

                  <Row>
                    <Col lg={12}>

                      <Table striped bordered hover responsive size="sm">
                        <thead>
                          <tr>
                            <th>Nome</th>
                            <th>WHATSAPP</th>
                            <th>grupo</th>
                            <th>Segue no Instagram?</th>
                            <th>Data</th>
                            <th className="w-25">Ações</th>
                          </tr>
                        </thead>
                        {data.length === 0 && (
                          <h5 className="text-muted text-center my-5">
                            Sem resultados
                          </h5>
                        )}
                        <tbody>
                          {data.map((categories) => (
                            <tr key={categories.id} className="w-25">
                              <td>{categories.nome}</td>
                              <td>{categories.numero_wpp}</td>
                              <td>{categories.grupo}</td>
                              <td>{categories.status == 1 ? "Sim" : "Não"}</td>
                              <td>
                                {categories.created_at
                                  ? new Date(categories.created_at).toLocaleDateString("pt-BR")
                                  : "Sem data"}
                              </td>
                              <td className="d-flex">


                                <Button
                                  size="sm"
                                  onClick={() => {
                                    let conf = window.confirm("Esta ação deletará o cartão fidelidade.");
                                    if (conf) {
                                      deleteEvento(categories).then(
                                        () => setMessage({
                                          error: false,
                                          content: "Categoria deletada com sucesso."
                                        }), () => setMessage({
                                          error: true,
                                          content: "Ocorreu um erro, tente novamente mais tarde."
                                        })
                                      )
                                      refresh();
                                    }
                                  }
                                  }
                                  variant="danger"
                                  className="text-white d-flex align-items-center"
                                >
                                  <MdDelete style={{ fontSize: "1.4em" }} />
                                </Button>

                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      {/* <div className="d-flex justify-content-end">
                        <Pagination>
                          <Pagination.First />
                          <Pagination.Prev />
                          <Pagination.Item active>{1}</Pagination.Item>
                          <Pagination.Item>{2}</Pagination.Item>
                          <Pagination.Item>{3}</Pagination.Item>
                          <Pagination.Next />
                          <Pagination.Last />
                        </Pagination>
                      </div> */}
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </div>
        </Container>
      </RedirectContainer>
    </>
  );
}
